import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import GenericGuideSectionTitleBlockData from '../../../Models/Content/GenericGuideSectionTitleBlockData';
import GenericGuideSectionTitle from './GenericGuideSectionTitleBlock';

export default class GenericGuideSectionTitleBlock extends EpiComponent<GenericGuideSectionTitleBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = ['generic-guide-section-title-block'];

    return (
      <div className={cssClasses.join(" ")}>
            <GenericGuideSectionTitle iContent={this.props.data} context={this.getContext()} />
      </div>
    )
  }
}

